import {
  AnimatedCheckMark,
  GpsFixIcon,
  ManualLocationRegistrationModal,
  MapWithMarker,
  Mtds
} from 'prove-common'
import { useState } from 'react'

type AccurateLocationProps = {
  position: GeolocationPosition
  sampleId?: string
  newSample?: boolean
  onSelectedLonLatChanged?: (lonLat: [number, number]) => void
}

export const AccurateLocation = ({
  position,
  sampleId,
  newSample,
  onSelectedLonLatChanged
}: AccurateLocationProps) => {
  const [isManualModalOpen, setIsManualModalOpen] = useState(false)

  return (
    <Mtds.Card as={Mtds.Grid} data-gap={8} className='bg-surface-tinted'>
      <Mtds.Flex
        data-align='center'
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          alignItems: 'center'
        }}
      >
        <Mtds.Info style={{ flex: 1, textAlign: 'left' }}>
          <GpsFixIcon />
          <strong>Posisjon funnet</strong> Posisjonen er nøyaktig nok
        </Mtds.Info>
        <AnimatedCheckMark size={48} />
      </Mtds.Flex>

      <MapWithMarker
        latitude={position.coords.latitude}
        longitude={position.coords.longitude}
      />
      <Mtds.Button
        data-variant={'secondary'}
        onClick={() => {
          setIsManualModalOpen(true)
        }}
      >
        Endre posisjon manuelt
      </Mtds.Button>
      {isManualModalOpen && (
        <ManualLocationRegistrationModal
          isManualModalOpen={isManualModalOpen}
          setIsManualModalOpen={setIsManualModalOpen}
          sampleId={sampleId}
          newSample={newSample}
          position={position}
          onSelectedLonLatChanged={onSelectedLonLatChanged}
        />
      )}
    </Mtds.Card>
  )
}
